import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import HeroSection from './components/HeroSection/HeroSection';
import Advantages from './components/Advantages/Advantages';
import Solutions from './components/Solutions/Solutions';
import Cases from './components/Cases/Cases';
import Testimonials from './components/Testimonials/Testimonials';
import NewsSection from './components/NewsSection/NewsSection';
import Footer from './components/Footer/Footer';
import ConsultForm from './components/ConsultForm/ConsultForm';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={
          <div>
            <Navbar />
            <HeroSection />
            <Advantages />
            <Solutions />
            <Cases />
            <Testimonials />
            <NewsSection />
            <Footer />
          </div>
        } />
        <Route path="/consult" element={<ConsultForm />} />
      </Routes>
    </Router>
  );
}

export default App;
